export { default } from './Comment';

import './Comment.scss';
